// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.batch_type_enum */
var BatchTypeEnum;
(function (BatchTypeEnum) {
    BatchTypeEnum["BROTH"] = "BROTH";
    BatchTypeEnum["SUPERNATANT"] = "SUPERNATANT";
    BatchTypeEnum["CONCENTRATE"] = "CONCENTRATE";
    BatchTypeEnum["POWDER"] = "POWDER";
    BatchTypeEnum["PERMEATE"] = "PERMEATE";
    BatchTypeEnum["RETENTATE"] = "RETENTATE";
    BatchTypeEnum["HOMOGENATE"] = "HOMOGENATE";
})(BatchTypeEnum || (BatchTypeEnum = {}));
;
export default BatchTypeEnum;
/** Zod schema for batch_type_enum */
export const batchTypeEnum = z.nativeEnum(BatchTypeEnum);
//# sourceMappingURL=BatchTypeEnum.js.map